export default __webpack_public_path__ + "b280b5e4819fe6b250e30b6b14f39d42.svg";